export default function TermsOfService() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-purple-50/20 to-pink-50/20 py-12 px-4">
      <div className="max-w-4xl mx-auto bg-white rounded-3xl shadow-xl p-8 md:p-12">
        <h1 className="text-4xl font-bold text-textDark mb-8">เงื่อนไขการใช้งาน</h1>
        
        <div className="space-y-6 text-textDark">
          <section>
            <h2 className="text-2xl font-bold mb-4">1. การยอมรับเงื่อนไข</h2>
            <p className="text-textLight leading-relaxed">
              การใช้งานแพลตฟอร์ม EduMi ถือว่าคุณยอมรับและตกลงที่จะปฏิบัติตามเงื่อนไขการใช้งานทั้งหมดที่ระบุไว้ในเอกสารนี้ 
              หากคุณไม่ยอมรับเงื่อนไขเหล่านี้ กรุณาหยุดการใช้งานแพลตฟอร์มทันที
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">2. การสมัครสมาชิกและบัญชีผู้ใช้</h2>
            <ul className="list-disc list-inside space-y-2 text-textLight">
              <li>คุณต้องให้ข้อมูลที่ถูกต้องและเป็นปัจจุบันในการสมัครสมาชิก</li>
              <li>คุณมีหน้าที่รับผิดชอบในการรักษาความปลอดภัยของรหัสผ่านและบัญชีของคุณ</li>
              <li>คุณต้องแจ้งให้เราทราบทันทีหากมีการใช้งานบัญชีของคุณโดยไม่ได้รับอนุญาต</li>
              <li>คุณต้องมีอายุอย่างน้อย 18 ปี หรือได้รับความยินยอมจากผู้ปกครอง</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">3. การใช้งานแพลตฟอร์ม</h2>
            <p className="text-textLight leading-relaxed mb-3">
              คุณตกลงที่จะใช้งานแพลตฟอร์มเพื่อวัตถุประสงค์ที่ถูกต้องตามกฎหมายเท่านั้น คุณจะไม่:
            </p>
            <ul className="list-disc list-inside space-y-2 text-textLight">
              <li>อัปโหลดเนื้อหาที่ผิดกฎหมาย หมิ่นประมาท หรือละเมิดสิทธิ์ของผู้อื่น</li>
              <li>แอบอ้างเป็นบุคคลหรือองค์กรอื่น</li>
              <li>รบกวนหรือขัดขวางการทำงานของแพลตฟอร์ม</li>
              <li>พยายามเข้าถึงข้อมูลหรือระบบที่คุณไม่มีสิทธิ์เข้าถึง</li>
              <li>ใช้แพลตฟอร์มเพื่อส่งสแปมหรือโฆษณาที่ไม่พึงประสงค์</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">4. เนื้อหาและทรัพย์สินทางปัญญา</h2>
            <p className="text-textLight leading-relaxed mb-3">
              เนื้อหาที่คุณอัปโหลดหรือสร้างบนแพลตฟอร์ม:
            </p>
            <ul className="list-disc list-inside space-y-2 text-textLight">
              <li>คุณยังคงเป็นเจ้าของลิขสิทธิ์ของเนื้อหาของคุณ</li>
              <li>คุณให้สิทธิ์แก่ EduMi ในการใช้ แสดง และเผยแพร่เนื้อหาของคุณบนแพลตฟอร์ม</li>
              <li>คุณรับประกันว่าคุณมีสิทธิ์ในการอัปโหลดเนื้อหานั้น</li>
              <li>EduMi ไม่รับผิดชอบต่อเนื้อหาที่ผู้ใช้อัปโหลด</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">5. การชำระเงินและการคืนเงิน</h2>
            <ul className="list-disc list-inside space-y-2 text-textLight">
              <li>ค่าบริการจะเรียกเก็บตามแพ็กเกจที่คุณเลือก</li>
              <li>การชำระเงินจะต้องชำระล่วงหน้าสำหรับรอบบิลถัดไป</li>
              <li>คุณสามารถยกเลิกการสมัครสมาชิกได้ทุกเมื่อ</li>
              <li>การคืนเงินจะพิจารณาเป็นรายกรณี ภายใน 7 วันหลังการชำระเงิน</li>
              <li>หากยกเลิกกลางเดือน จะไม่มีการคืนเงินส่วนที่เหลือ</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">6. การยกเลิกบัญชี</h2>
            <p className="text-textLight leading-relaxed">
              EduMi ขอสงวนสิทธิ์ในการระงับหรือยกเลิกบัญชีของคุณหากคุณละเมิดเงื่อนไขการใช้งาน 
              โดยไม่ต้องแจ้งให้ทราบล่วงหน้า และไม่มีการคืนเงิน
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">7. การจำกัดความรับผิด</h2>
            <p className="text-textLight leading-relaxed">
              EduMi ให้บริการในสภาพ "ตามที่เป็น" เราไม่รับประกันว่าบริการจะไม่มีข้อผิดพลาดหรือไม่หยุดชะงัก 
              เราจะไม่รับผิดชอบต่อความเสียหายใดๆ ที่เกิดจากการใช้งานหรือไม่สามารถใช้งานแพลตฟอร์ม
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">8. การเปลี่ยนแปลงเงื่อนไข</h2>
            <p className="text-textLight leading-relaxed">
              EduMi ขอสงวนสิทธิ์ในการเปลี่ยนแปลงเงื่อนไขการใช้งานได้ทุกเมื่อ 
              การเปลี่ยนแปลงจะมีผลทันทีเมื่อเผยแพร่บนเว็บไซต์ 
              การใช้งานแพลตฟอร์มต่อไปถือว่าคุณยอมรับเงื่อนไขที่เปลี่ยนแปลง
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">9. กฎหมายที่ใช้บังคับ</h2>
            <p className="text-textLight leading-relaxed">
              เงื่อนไขการใช้งานนี้อยู่ภายใต้กฎหมายของประเทศไทย 
              ข้อพิพาทใดๆ จะอยู่ในเขตอำนาจของศาลไทย
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">10. ติดต่อเรา</h2>
            <p className="text-textLight leading-relaxed">
              หากคุณมีคำถามเกี่ยวกับเงื่อนไขการใช้งาน กรุณาติดต่อเราที่:
            </p>
            <ul className="list-none space-y-2 text-textLight mt-3">
              <li>📧 อีเมล: support@edumi.co</li>
              <li>📱 โทร: 02-XXX-XXXX</li>
              <li>🏢 ที่อยู่: กรุงเทพมหานคร ประเทศไทย</li>
            </ul>
          </section>

          <div className="mt-8 pt-8 border-t border-gray-200">
            <p className="text-sm text-textLight">
              อัปเดตล่าสุด: 14 ธันวาคม 2025
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
